const recaptchakey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const base_root = window.location.host

let apiUrl = '';

if (base_root === "polarcare.polar-air.com") {
      apiUrl = 'https://api-polarserv.polar-air.com';
}
else if (base_root === "polarcare-staging.polar-air.com") {
      apiUrl = 'https://api-polarserv-staging.polar-air.com';
}
else if (base_root === "alsamart.com") {
      apiUrl = 'https://api-prod.alsamart.com';
}
else if (base_root === "dev.alsamart.com") {
      apiUrl = 'https://api-dev.alsamart.com';
}
else if (base_root === "ogs.daroy.net" || base_root === "ogs.topventory.com") {
      apiUrl = 'https://api-ogs.topventory.com';
}
else if (base_root === "app.topventory.com") {
//else if (base_root === "app.asinso.com" || base_root === "www.asinso.com" || base_root === "app.asinso.net" || base_root === "asinso.net" || base_root === "www.asinso.net" || base_root === "app.topventory.com") {
      apiUrl = process.env.REACT_APP_API_PROD_URL;
}
else if (base_root === "beta.topventory.com") {
      apiUrl = process.env.REACT_APP_API_BETA_URL;
}
else if (base_root === "demo.topventory.com") {
      apiUrl = process.env.REACT_APP_API_DEMO_URL;
}
else{
      apiUrl = process.env.REACT_APP_API_DEV_URL;
}

const appConfig = {
      apiUrl,
      recaptchakey
}

export default appConfig;